<script setup lang="ts">
import {
  AccordionHeader,
  AccordionTrigger,
  type AccordionTriggerProps,
} from 'radix-vue'
import AddIcon from '~icons/mdi/add'
import RemoveIcon from '~icons/mdi/minus'
import { cn } from '../../../lib/utils';

const props = defineProps<AccordionTriggerProps & { class?: string }>()
</script>

<template>
  <AccordionHeader class="c-accordion__header flex border-none" as="div">
    <AccordionTrigger
      v-bind="props"
      :class="
        cn(
          'c-accordion__trigger',
          props.class,
        )
      "
    >
      <slot />
      <AddIcon
        class="c-accordion__trigger__icon c-accordion__trigger__icon--closed"
      />
      <RemoveIcon
        class="c-accordion__trigger__icon c-accordion__trigger__icon--open"
      />
    </AccordionTrigger>
  </AccordionHeader>
</template>

<style scoped>
.c-accordion__trigger__icon--open {
    display: none;
}

.c-accordion__trigger {
  padding-top: var(--c-accordion-vertical-padding);
  padding-bottom: var(--c-accordion-vertical-gap);
  display: flex;
  flex: theme("flex.1");
  align-items: center;
  justify-content: space-between;
  font-weight: theme("fontWeight.bold");
  color: var(--c-accordion-title-color);
  text-align: left;
}

.c-accordion__trigger__icon {
  width: theme("width.16");
  height: theme("width.16");
  flex-shrink: 0;
  color: var(--c-accordion-icon-color);
}

.c-accordion__trigger {
  &[data-state=open] {
    & .c-accordion__trigger__icon--closed {
      display: none;
    }
    & .c-accordion__trigger__icon--open {
      display: block;
    }
  }
}

</style>
